$bog_smalljs_playground $mol_view
	tab \tree
	draft? \
	ts_draft? \
	css_draft? \
	editor_hint \
	seed_tree \
	seed_ts \
	seed_css \
	store_scope \
	sample_title* \
	sample_pick*? null
	sample_hello_title @ \Hello world
	sample_counter_title @ \Counter
	sample_fetch_title @ \Loading data
	sample_args_title @ \URL arguments
	sample_routing_title @ \Routing
	sample_state_title @ \Saved state
	sample_login_title @ \Login form
	Sample_option* $mol_button_minor
		click? <=> sample_pick*?
		sub /
			<= sample_title*
	shared false
	share_hint @ \Copy a link to this code
	share_done_hint @ \Link copied
	share? null
	editors_mode? \tabs
	layout_hint @ \Show all files at once
	layout_hint_tabs @ \Back to tabs
	layout_toggle? null
	files_showed false
	files_tree \
	active_file \
	file_pick? null
	files_title @ \Project
	files_note @ \Where these files live in a MAM workspace
	attr *
		bog_smalljs_pg_tab <= tab
		bog_smalljs_pg_editors <= editors_mode?
		bog_smalljs_pg_files <= files_showed
		bog_smalljs_pg_shared <= shared
	sub /
		<= Files $mol_view
			sub /
				<= Files_label $mol_view
					sub /
						<= files_title
				<= Files_tree $bog_smalljs_structure
					tree <= files_tree
					active <= active_file
					pickable true
					plain true
					file? <=> file_pick?
				<= Files_note $mol_view
					sub /
						<= files_note
		<= Editor_pane $mol_view
			sub /
				<= Tabs $mol_view
					sub <= tabs_content /
						<= Tree_tab $mol_button_minor
							click? <=> show_tree? null
							sub / <= tree_tab_label @ \view.tree
						<= Ts_tab $mol_button_minor
							click? <=> show_ts? null
							sub / <= ts_tab_label @ \view.ts
						<= Css_tab $mol_button_minor
							click? <=> show_css? null
							sub / <= css_tab_label @ \view.css.ts
						<= Tabs_gap $mol_view
						<= Samples $mol_pick
							hint <= samples_hint @ \Examples
							align \bottom_right
							trigger_content /
								<= Samples_label $mol_view
									sub / <= samples_label \
								<= Samples_chevron $mol_icon_chevron_down
							bubble_content /
								<= Samples_menu $mol_view
									sub <= sample_options /
						<= Layout_toggle $mol_button_minor
							hint <= layout_title \
							click? <=> layout_toggle? null
							sub /
								<= Layout_icon $mol_icon_view_agenda
						<= Share $mol_button_minor
							hint <= share_title \
							click? <=> share? null
							sub <= share_content /
								<= Share_icon $mol_icon_share_variant_outline
								<= Share_done_icon $mol_icon_check
								<= Share_done_label $mol_view
									sub /
										<= share_done_label @ \Copied
						<= Reset $mol_button_minor
							hint <= reset_hint @ \Restore the example
							click? <=> reset? null
							sub /
								<= Reset_icon $mol_icon_restore
				<= Editors $mol_view
					sub /
						<= Editor_tree_label $mol_view
							sub / <= tree_tab_label
						<= Editor $mol_textarea
							value? <=> draft?
							hint <= editor_hint
						<= Editor_ts_label $mol_view
							sub / <= ts_tab_label
						<= Editor_ts $mol_textarea
							value? <=> ts_draft?
							hint <= editor_hint_ts @ \Optional — logic for the component.
						<= Editor_css_label $mol_view
							sub / <= css_tab_label
						<= Editor_css $mol_textarea
							value? <=> css_draft?
							hint <= editor_hint_css @ \Optional — typed styles.
		<= Preview_pane $mol_view
			sub /
				<= Preview_label $mol_view
					sub /
						<= preview_label_text @ \Preview
						<= Preview_gap $mol_view
						<= Log_toggle $mol_button_minor
							click? <=> log_toggle? null
							sub / <= log_toggle_label \
				<= Preview $mol_view
					sub <= preview_content /
				<= Log $mol_view
					attr *
						^
						bog_smalljs_pg_log_shown <= log_shown false
					sub /
						<= Log_head $mol_view
							sub /
								<= Log_title $mol_view
									sub / <= log_title_text @ \Console
								<= Log_gap $mol_view
								<= Log_clear $mol_button_minor
									hint <= log_clear_hint @ \Clear
									click? <=> log_clear? null
									sub / \✕
						<= Log_list $mol_view
							sub <= log_rows /
	log_open? false
	log_shown false
	log_text* \
	log_level* \
	Log_row* $mol_view
		attr *
			^
			bog_smalljs_pg_level <= log_level*
		sub / <= log_text*
